import type { CreateOnboardingTemplateFromDescriptionRequest } from '@gb-ticket/shared-types';

type Kind = CreateOnboardingTemplateFromDescriptionRequest['kind'];

export type OnboardingDraftExample = {
  style: 'short' | 'phases' | 'assignees';
  label: string;
  name: string;
  prompt: string;
};

const ENTRY_NAME = 'Standard-Eintritt';
const EXIT_NAME = 'Standard-Austritt';

export const ONBOARDING_DRAFT_EXAMPLES: Record<Kind, readonly OnboardingDraftExample[]> = {
  onboarding: [
    {
      style: 'short',
      label: 'Kurz',
      name: ENTRY_NAME,
      prompt:
        'Lege den Standard-Eintritt unseres Unternehmens an. Drei Phasen: Vorbereitung vor dem ersten Tag, erster Tag und erste Wochen. Beteiligt sind Personal, IT, Fuhrpark, die vorgesetzte Person und die neue Person. Enthalten sind Unterlagen, Geräteausgabe und ein Fahrzeug nur, wenn eines vorgesehen ist. Benutzerkonto, Gehaltsstamm und Probezeitgespräch sind reine Bestätigungen, ohne technische Anbindung.',
    },
    {
      style: 'phases',
      label: 'Mit Phasen',
      name: ENTRY_NAME,
      prompt:
        'Lege den Standard-Eintritt unseres Unternehmens in drei Phasen an. Vorbereitung vor dem ersten Tag: Personal prüft Vertrag und Stammdaten und fordert die Unterlagen an. IT bereitet das Benutzerkonto sowie Arbeitsplatz und Zugänge vor. Personal legt den Gehaltsstamm an. Konto und Gehalt sind reine Bestätigungen. Die neue Person hat in dieser Phase noch kein Konto. Geräte und Fahrzeug werden hier noch nicht ausgegeben. Erster Tag: IT gibt die Geräte aus. Fuhrpark ordnet ein Fahrzeug zu, nur wenn eines vorgesehen ist. Die vorgesetzte Person begrüßt und weist ein. Die neue Person ergänzt ihre Daten und lädt Unterlagen hoch. Erste Wochen: Die vorgesetzte Person prüft die Einarbeitung. Personal bereitet das Probezeitgespräch vor, wieder als Bestätigung.',
    },
    {
      style: 'assignees',
      label: 'Mit zuständigen Stellen',
      name: ENTRY_NAME,
      prompt:
        'Lege den Standard-Eintritt unseres Unternehmens an. Jede Aufgabe nennt die zuständige Stelle. Personal, Vorbereitung: Vertrag und Stammdaten prüfen, Unterlagen anfordern, Gehaltsstamm anlegen als Bestätigung. IT, Vorbereitung: Benutzerkonto vorbereiten als Bestätigung, Arbeitsplatz und Zugänge vorbereiten. IT, erster Tag: Geräte ausgeben. Fuhrpark, erster Tag: Fahrzeug zuordnen, nur wenn eines vorgesehen ist. Vorgesetzte Person, erster Tag: Begrüßung und Einweisung. Neue Person, erster Tag: Daten ergänzen und Unterlagen hochladen. Vorgesetzte Person, erste Wochen: Einarbeitung prüfen. Personal, erste Wochen: Probezeitgespräch vorbereiten als Bestätigung.',
    },
  ],
  offboarding: [
    {
      style: 'short',
      label: 'Kurz',
      name: EXIT_NAME,
      prompt:
        'Lege den Standard-Austritt unseres Unternehmens an. Drei Phasen: Übergabe vor dem letzten Arbeitstag, letzter Arbeitstag und Nachbereitung. Beteiligt sind Personal, IT, Fuhrpark, die vorgesetzte Person und die austretende Person. Enthalten sind Wissensübergabe, Geräterückgabe und Fahrzeugrückgabe nur, wenn eines zugeordnet ist. Kontosperre, Zeugnis und Gehaltsabschluss sind reine Bestätigungen, ohne technische Anbindung.',
    },
    {
      style: 'phases',
      label: 'Mit Phasen',
      name: EXIT_NAME,
      prompt:
        'Lege den Standard-Austritt unseres Unternehmens in drei Phasen an. Übergabe vor dem letzten Arbeitstag: Die vorgesetzte Person organisiert die Wissensübergabe. Die austretende Person übergibt offene Aufgaben. IT listet die Zugänge. Personal stellt die Austrittsunterlagen bereit. Letzter Arbeitstag: IT nimmt die Geräte zurück. Fuhrpark nimmt das Fahrzeug zurück, nur wenn eines zugeordnet ist. IT bestätigt die Deaktivierung des Benutzerkontos, ohne technische Sperre. Die austretende Person bestätigt die Rückgabe von Schlüsseln und Zugängen. Nachbereitung: Personal erstellt das Zeugnis und schließt die Gehaltsabrechnung ab, beides als Bestätigung. Die vorgesetzte Person bestätigt den Abschluss.',
    },
    {
      style: 'assignees',
      label: 'Mit zuständigen Stellen',
      name: EXIT_NAME,
      prompt:
        'Lege den Standard-Austritt unseres Unternehmens an. Jede Aufgabe nennt die zuständige Stelle. Vorgesetzte Person, Übergabe: Wissensübergabe organisieren. Austretende Person, Übergabe: offene Aufgaben übergeben. IT, Übergabe: Zugänge auflisten. Personal, Übergabe: Austrittsunterlagen bereitstellen. IT, letzter Arbeitstag: Geräte zurücknehmen und Benutzerkonto deaktivieren, das Konto nur als Bestätigung. Fuhrpark, letzter Arbeitstag: Fahrzeug zurücknehmen, nur wenn eines zugeordnet ist. Austretende Person, letzter Arbeitstag: Rückgabe von Schlüsseln und Zugängen bestätigen. Personal, Nachbereitung: Zeugnis erstellen und Gehaltsabrechnung abschließen, beides als Bestätigung. Vorgesetzte Person, Nachbereitung: Abschluss bestätigen.',
    },
  ],
};
